import { Grid } from '@mui/material';
import React from 'react';

import TabPanel from '../../TabPanel';
import { type SettingsModalTabProps } from '../../types';
import AccessContainer from '../AccessContainer';
import UserList from '../UserList';

import PermissionMatrixProvider from '@/Contexts/PermissionMatrix/Provider';

const PermissionsTab: React.FC<SettingsModalTabProps> = ({ parentTab, index }) => {
  return (
    <TabPanel value={parentTab} index={index}>
      <PermissionMatrixProvider>
        <Grid
          container
          height="100%"
          alignContent="flex-start"
          flex={1}
          sx={{ minHeight: 0 }}
          data-testid="permissions-grid-container"
        >
          <UserList />
          <AccessContainer />
        </Grid>
      </PermissionMatrixProvider>
    </TabPanel>
  );
};

export default PermissionsTab;
